// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendarPopup_lMgZy {
	position: absolute;
	top: 100%;
	left: 0;
	flex-direction: column;
	z-index: 100;
	background-color: white;
	border: 1px solid var(--border-color);
	border-radius: 4px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	padding: 10px;
	margin-top: 5px;
	z-index: 100000;
}
.miniCalendarWrapper_o2M5p {
	background: var(--f5-background);
	border-radius: 10px;
	padding: 2px;
	overflow: hidden;
}

.date_Urv5U {
	display: flex;
	align-items: center;
	gap: 2px;
	justify-content: space-between;
	b {
		color: var(--_10a37f-background);
		font-size: 12px;
		font-weight: 600;
	}
	div {
		display: flex;
		align-items: center;
		gap: 10px;

		button {
			transition:
				background 0.2s ease-in-out,
				transform 0.1s ease-in-out;
			cursor: pointer;
			-webkit-user-select: none;
			        user-select: none;
			padding: 3px;
			background: var(--_16c0982e-background);
			color: var(--_10a37f-background);
			border-radius: 6px;
			&:hover {
				background: var(--_16c0982e-background);
				transform: scale(1.05);
			}

			&:active {
				background: var(--_16c098-color);
				transform: scale(0.95);
			}
			svg {
				width: 8px;
				height: 8px;
			}
		}
	}
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/CalendarPopup.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,sBAAsB;CACtB,YAAY;CACZ,uBAAuB;CACvB,qCAAqC;CACrC,kBAAkB;CAClB,wCAAwC;CACxC,aAAa;CACb,eAAe;CACf,eAAe;AAChB;AACA;CACC,gCAAgC;CAChC,mBAAmB;CACnB,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,8BAA8B;CAC9B;EACC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;CACjB;CACA;EACC,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET;GACC;;8BAE2B;GAC3B,eAAe;GACf,yBAAiB;WAAjB,iBAAiB;GACjB,YAAY;GACZ,uCAAuC;GACvC,gCAAgC;GAChC,kBAAkB;GAClB;IACC,uCAAuC;IACvC,sBAAsB;GACvB;;GAEA;IACC,gCAAgC;IAChC,sBAAsB;GACvB;GACA;IACC,UAAU;IACV,WAAW;GACZ;EACD;CACD;AACD","sourcesContent":[".calendarPopup {\n\tposition: absolute;\n\ttop: 100%;\n\tleft: 0;\n\tflex-direction: column;\n\tz-index: 100;\n\tbackground-color: white;\n\tborder: 1px solid var(--border-color);\n\tborder-radius: 4px;\n\tbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\tpadding: 10px;\n\tmargin-top: 5px;\n\tz-index: 100000;\n}\n.miniCalendarWrapper {\n\tbackground: var(--f5-background);\n\tborder-radius: 10px;\n\tpadding: 2px;\n\toverflow: hidden;\n}\n\n.date {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tjustify-content: space-between;\n\tb {\n\t\tcolor: var(--_10a37f-background);\n\t\tfont-size: 12px;\n\t\tfont-weight: 600;\n\t}\n\tdiv {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\n\t\tbutton {\n\t\t\ttransition:\n\t\t\t\tbackground 0.2s ease-in-out,\n\t\t\t\ttransform 0.1s ease-in-out;\n\t\t\tcursor: pointer;\n\t\t\tuser-select: none;\n\t\t\tpadding: 3px;\n\t\t\tbackground: var(--_16c0982e-background);\n\t\t\tcolor: var(--_10a37f-background);\n\t\t\tborder-radius: 6px;\n\t\t\t&:hover {\n\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\ttransform: scale(1.05);\n\t\t\t}\n\n\t\t\t&:active {\n\t\t\t\tbackground: var(--_16c098-color);\n\t\t\t\ttransform: scale(0.95);\n\t\t\t}\n\t\t\tsvg {\n\t\t\t\twidth: 8px;\n\t\t\t\theight: 8px;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calendarPopup": `calendarPopup_lMgZy`,
	"miniCalendarWrapper": `miniCalendarWrapper_o2M5p`,
	"date": `date_Urv5U`
};
export default ___CSS_LOADER_EXPORT___;
